<template>
  <div class="customer-form-container">
    <el-form :model="customerForm" :rules="customerRules" ref="customerForm" 
             :label-width="isMobile ? '80px' : '100px'" 
             :class="{'mobile-form': isMobile}">
      <el-form-item label="客户名称" prop="name">
        <el-input v-model="customerForm.name" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="customerForm.phone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      
      <el-form-item label="地址" prop="address">
        <el-input
          v-model="customerForm.address"
          placeholder="请输入地址"
          type="textarea"
          :rows="isMobile ? 4 : 3"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="备注">
        <el-input v-model="customerForm.description" placeholder="请输入备注" type="textarea" :rows="isMobile ? 4 : 3"></el-input>
      </el-form-item>
      
      <el-form-item label="位置">
        <div class="map-section">
          <!-- 地图搜索控件 -->
          <div class="map-search">
            <el-input 
              v-model="searchKeyword" 
              placeholder="请输入搜索地址" 
              @keyup.enter="handleMapSearch"
              class="map-search-input"
            >
              <template slot="append">
                <i class="el-icon-search" @click="handleMapSearch"></i>
              </template>
            </el-input>
            <div class="map-actions">
              <el-button type="primary" size="mini" @click="handleGeocode">根据地址定位</el-button>
              <el-button size="mini" @click="handleLocateCurrentPosition">定位当前位置</el-button>
              <el-button type="text" size="mini" class="map-fullscreen-btn" @click="openFullscreenMap">全屏地图</el-button>
            </div>
            <span class="map-drag-hint">可直接点击地图选点，也可用搜索/定位；有标记后可拖动微调。黑色细十字为坐标锚点，与图钉尖对齐。</span>
          </div>
          
          <el-amap
            class="map"
            :center="mapCenter"
            :zoom="14"
            :scroll-wheel-zoom="true"
            :events="amapEvents"
          >
            <el-amap-marker
              v-if="customerForm.longitude != null && customerForm.latitude != null"
              :position="[Number(customerForm.longitude), Number(customerForm.latitude)]"
              :draggable="true"
              :raise-on-drag="false"
              :offset="markerVisualOffset"
              cursor="move"
              :events="markerEvents"
            >
              <div class="customer-marker customer-marker--draggable" title="拖动可微调位置">
                <i class="el-icon-location customer-marker__icon"></i>
              </div>
            </el-amap-marker>
          </el-amap>
          
          <div class="map-controls" :class="{'mobile-controls': isMobile}">
            <div class="coordinates" :class="{'mobile-coordinates': isMobile}">
              <span>经度: {{ customerForm.longitude || '未设置' }}</span>
              <span>纬度: {{ customerForm.latitude || '未设置' }}</span>
            </div>
          </div>
        </div>

        <!-- 全屏地图层：在手机端尤其方便拖动 / 精调 -->
        <transition name="fade">
          <div
            v-if="fullscreenMapVisible"
            class="map-fullscreen-overlay"
          >
            <div class="map-fullscreen-header">
              <div class="map-fullscreen-top">
                <span class="map-fullscreen-title">选择客户位置</span>
                <el-button size="mini" @click="closeFullscreenMap">完成</el-button>
              </div>
              <div class="map-fullscreen-search">
                <el-input
                  v-model="searchKeyword"
                  placeholder="请输入搜索地址"
                  @keyup.enter="handleMapSearch"
                  class="map-fullscreen-search-input"
                >
                  <template slot="append">
                    <i class="el-icon-search" @click="handleMapSearch"></i>
                  </template>
                </el-input>
                <el-button type="primary" size="mini" @click="handleGeocode">根据地址定位</el-button>
                <el-button size="mini" @click="handleLocateCurrentPosition">定位当前位置</el-button>
              </div>
              <div class="map-fullscreen-actions">
                <div v-if="customerForm.address" class="map-fullscreen-address" :title="customerForm.address">
                  地址：{{ customerForm.address }}
                </div>
                <div class="map-fullscreen-coord">
                  经度: {{ customerForm.longitude || '未设置' }}，
                  纬度: {{ customerForm.latitude || '未设置' }}
                </div>
              </div>
            </div>
            <div class="map-fullscreen-body">
              <el-amap
                class="map-fullscreen-map"
                :center="mapCenter"
                :zoom="fullscreenZoom"
                :scroll-wheel-zoom="true"
                :events="fullscreenAmapEvents"
              >
                <el-amap-marker
                  v-if="customerForm.longitude != null && customerForm.latitude != null"
                  :position="[Number(customerForm.longitude), Number(customerForm.latitude)]"
                  :draggable="true"
                  :raise-on-drag="false"
                  :offset="markerVisualOffset"
                  cursor="move"
                  :events="markerEvents"
                >
                  <div class="customer-marker customer-marker--draggable" title="拖动可微调位置">
                    <i class="el-icon-location customer-marker__icon"></i>
                  </div>
                </el-amap-marker>
              </el-amap>
            </div>
          </div>
        </transition>
      </el-form-item>
      
      <el-form-item label="管理者">
        <el-select v-model="customerForm.managerId" placeholder="请选择管理者" style="width: 100%">
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="user.name"
            :value="user.id"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item class="form-buttons">
        <el-button type="primary" @click="handleSubmit" :class="{'mobile-button': isMobile}">提交</el-button>
        <el-button @click="handleReset" :class="{'mobile-button': isMobile}">重置</el-button>
        <el-button @click="$router.go(-1)" :class="{'mobile-button': isMobile}">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '../utils/request'
import { getUserInfo } from '../utils/auth'

export default {
  name: 'CustomerForm',
  props: {
    customerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      customerForm: {
        id: null,
        name: '',
        phone: '',
        address: '',
        longitude: null,
        latitude: null,
        description: '',
        managerId: null
      },
      customerRules: {
        name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ]
      },
      users: [],
      map: null,
      mapCenter: [87.616878, 43.82567],
      fullscreenMapVisible: false,
      fullscreenZoom: 16,
      searchKeyword: '',
      markerEvents: {
        dragend: (e) => this.handleMarkerDragEnd(e)
      },
      amapEvents: {
        init: (mapInstance) => this.handleMapInit(mapInstance),
        click: (e) => this.handleMapClick(e)
      },
      fullscreenAmapEvents: {
        click: (e) => this.handleMapClick(e)
      },
      /** 与 .customer-marker 尺寸配套：底边中点对齐经纬度/高德锚点 */
      markerVisualOffset: [-22, -52],
      isMobile: false
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    
    this.loadUsers()
    
    // 如果是编辑模式，加载客户信息
    if (this.customerId) {
      this.loadCustomerInfo()
    } else {
      // 默认设置当前用户为管理者
      const currentUser = getUserInfo()
      if (currentUser) {
        this.customerForm.managerId = currentUser.id
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768
    },
    
    // 加载用户列表
    loadUsers() {
      request.get('/users')
        .then(response => {
          this.users = response.data || response
        })
        .catch(error => {
          console.error('加载用户列表失败:', error)
          this.$message.error('加载用户列表失败')
        })
    },
    
    // 加载客户信息
    loadCustomerInfo() {
      request.get(`/customers/${this.customerId}`)
        .then(response => {
          const customer = response.data || response
          this.customerForm = {
            id: customer.id,
            name: customer.name,
            phone: customer.phone,
            address: customer.address,
            longitude: customer.longitude,
            latitude: customer.latitude,
            description: customer.description,
            managerId: customer.manager.id
          }
          
          // 设置地图中心
          if (customer.longitude && customer.latitude) {
            this.mapCenter = [customer.longitude, customer.latitude]
          }
        })
        .catch(error => {
          console.error('加载客户信息失败:', error)
          this.$message.error('加载客户信息失败')
        })
    },

    openFullscreenMap() {
      this.fullscreenMapVisible = true
      // 进入全屏时，若已有坐标，则稍微放大一级方便精细拖动
      if (this.customerForm.longitude && this.customerForm.latitude) {
        this.fullscreenZoom = 17
        this.mapCenter = [Number(this.customerForm.longitude), Number(this.customerForm.latitude)]
      } else {
        this.fullscreenZoom = 14
      }
    },

    closeFullscreenMap() {
      this.fullscreenMapVisible = false
    },

    handleMapInit(mapInstance) {
      // 手动添加地图控件，保证在所有环境都能显示（右下角缩放、左下角比例尺）
      this.map = mapInstance

      if (!window.AMap || !mapInstance || !mapInstance.addControl) return

      // 防重复添加（编辑页/热更新等情况下 init 可能多次触发）
      if (this._mapControlsInited) return
      this._mapControlsInited = true

      try {
        if (window.AMap.ToolBar) {
          const toolBar = new window.AMap.ToolBar({
            position: 'RB',
            liteStyle: false
          })
          mapInstance.addControl(toolBar)
        }

        if (window.AMap.Scale) {
          const scale = new window.AMap.Scale({
            position: 'LB'
          })
          mapInstance.addControl(scale)
        }
      } catch (e) {
        // 控件添加失败不影响主流程（选点/拖拽）
        // eslint-disable-next-line no-console
        console.error('地图控件初始化失败:', e)
      }
    },
    
    // 点击地图（须通过 el-amap 的 :events 注册，@click 无法收到高德地图点击）
    handleMapClick(e) {
      const ll = e && e.lnglat
      if (!ll) return
      const lng = typeof ll.getLng === 'function' ? ll.getLng() : ll.lng
      const lat = typeof ll.getLat === 'function' ? ll.getLat() : ll.lat
      this.customerForm.longitude = lng
      this.customerForm.latitude = lat
      this.mapCenter = [lng, lat]

      this.reverseGeocode(lng, lat)

      this.$message.success('已在地图选点，可拖动标记微调')
    },

    _lngLatFromDragEvent(e) {
      const ll = e && e.lnglat
      if (!ll) return null
      const lng = typeof ll.getLng === 'function' ? ll.getLng() : ll.lng
      const lat = typeof ll.getLat === 'function' ? ll.getLat() : ll.lat
      if (lng == null || lat == null) return null
      return { lng, lat }
    },

    // 标记拖拽结束
    handleMarkerDragEnd(e) {
      const pos = this._lngLatFromDragEvent(e)
      if (!pos) return

      this.customerForm.longitude = pos.lng
      this.customerForm.latitude = pos.lat
      this.mapCenter = [pos.lng, pos.lat]

      this.reverseGeocode(pos.lng, pos.lat)

      this.$message.success('已根据标记位置更新坐标')
    },
    
    // 根据地址定位
    handleGeocode() {
      if (!this.customerForm.address) {
        this.$message.warning('请先输入地址')
        return
      }
      
      // 确保高德地图API已加载
      if (window.AMap && window.AMap.Geocoder) {
        console.log('正在请求地理编码API，地址:', this.customerForm.address)
        
        // 使用高德地图API进行地址解析
        const geocoder = new window.AMap.Geocoder({
          city: '', // 城市，默认全国
          radius: 1000 // 范围，默认：500
        })
        
        geocoder.getLocation(this.customerForm.address, (status, result) => {
          console.log('地理编码API响应:', { status, result })
          
          if (status === 'complete' && result.geocodes && result.geocodes.length > 0) {
            const location = result.geocodes[0].location
            console.log('解析到的位置:', location)
            this.customerForm.longitude = location.lng
            this.customerForm.latitude = location.lat
            this.mapCenter = [location.lng, location.lat]
            this.$message.success('定位成功')
          } else {
            console.error('地理编码失败:', status, result)
            // 根据错误类型提供更详细的错误信息
            let errorMsg = '无法定位到该地址'
            if (result && result.info === 'INVALID_USER_SCODE') {
              errorMsg = '定位服务配置错误，请检查API安全码设置'
            } else if (result && result.info) {
              errorMsg = `定位失败: ${result.info}`
            }
            this.$message.error(errorMsg)
          }
        })
      } else {
        console.error('高德地图API或Geocoder插件未加载成功:', { AMap: window.AMap, Geocoder: window.AMap ? window.AMap.Geocoder : null })
        this.$message.error('地图服务加载失败，请稍后重试')
      }
    },
    
    // 地图搜索
    handleMapSearch() {
      if (!this.searchKeyword) {
        this.$message.warning('请输入搜索地址')
        return
      }
      
      if (window.AMap && window.AMap.Geocoder) {
        console.log('正在搜索地址:', this.searchKeyword)
        
        const geocoder = new window.AMap.Geocoder({
          city: '', // 城市，默认全国
          radius: 1000
        })
        
        geocoder.getLocation(this.searchKeyword, (status, result) => {
          if (status === 'complete' && result.geocodes && result.geocodes.length > 0) {
            const location = result.geocodes[0].location
            const formattedAddress = result.geocodes[0].formattedAddress
            
            console.log('搜索到的位置:', location)
            console.log('搜索到的地址:', formattedAddress)
            
            // 更新地图中心和标记
            this.customerForm.longitude = location.lng
            this.customerForm.latitude = location.lat
            this.customerForm.address = formattedAddress
            this.mapCenter = [location.lng, location.lat]

            this.$message.success('搜索成功')
          } else {
            console.error('搜索失败:', status, result)
            this.$message.error('无法搜索到该地址')
          }
        })
      } else {
        console.error('高德地图API或Geocoder插件未加载成功')
        this.$message.error('地图服务加载失败，请稍后重试')
      }
    },
    
    // 坐标转地址
    reverseGeocode(longitude, latitude) {
      if (!window.AMap || !window.AMap.Geocoder) {
        console.error('高德地图API或Geocoder插件未加载成功')
        return
      }
      
      const geocoder = new window.AMap.Geocoder()
      const lnglat = [longitude, latitude]
      
      geocoder.getAddress(lnglat, (status, result) => {
        if (status === 'complete' && result.regeocode) {
          const formattedAddress = result.regeocode.formattedAddress
          this.customerForm.address = formattedAddress
          console.log('坐标转地址成功:', formattedAddress)
        } else {
          console.error('坐标转地址失败:', status, result)
        }
      })
    },

    // 根据浏览器当前位置定位
    handleLocateCurrentPosition() {
      if (!navigator.geolocation) {
        this.$message.error('当前浏览器不支持地理定位')
        return
      }

      this.$message.info('正在获取当前位置...')

      const applyLocation = (lng, lat) => {
        this.customerForm.longitude = lng
        this.customerForm.latitude = lat
        this.mapCenter = [lng, lat]
        this.reverseGeocode(lng, lat)
        this.$message.success('已定位到当前位置')
      }

      const locateOnce = (options, hasRetried) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lng = position.coords.longitude
            const lat = position.coords.latitude

            // 如果高德提供坐标转换，则从 WGS84 转到高德坐标系
            if (window.AMap && window.AMap.convertFrom) {
              window.AMap.convertFrom([lng, lat], 'gps', (status, result) => {
                if (status === 'complete' && result.locations && result.locations.length > 0) {
                  const loc = result.locations[0]
                  applyLocation(loc.lng, loc.lat)
                } else {
                  applyLocation(lng, lat)
                }
              })
            } else {
              applyLocation(lng, lat)
            }
          },
          (error) => {
            console.error('定位失败:', error)

            // 超时/不可用时，做一次宽松重试（部分环境启用高精度会很慢）
            if (!hasRetried && (error.code === error.TIMEOUT || error.code === error.POSITION_UNAVAILABLE)) {
              this.$message.warning('定位超时/不可用，正在重试...')
              setTimeout(() => {
                locateOnce({
                  enableHighAccuracy: false,
                  timeout: 30000,
                  maximumAge: 60000
                }, true)
              }, 1200)
              return
            }

            let msg = '获取当前位置失败'
            if (error.code === error.PERMISSION_DENIED) {
              msg = '定位权限被拒绝，请在浏览器中允许访问位置信息'
            } else if (error.code === error.POSITION_UNAVAILABLE) {
              msg = '位置信息不可用'
            } else if (error.code === error.TIMEOUT) {
              msg = '获取位置信息超时，请稍后重试'
            }

            // 额外带上 error.message，便于你控制台排查
            this.$message.error(msg + (error && error.message ? `（${error.message}）` : ''))
          },
          options
        )
      }

      // 先用“更快更稳”的配置；如果环境允许，会很快返回
      locateOnce({
        enableHighAccuracy: false,
        timeout: 20000,
        maximumAge: 30000
      }, false)
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          // 构建请求数据
          const requestData = {
            ...this.customerForm,
            manager: { id: this.customerForm.managerId }
          }
          
          // 根据是新增还是编辑选择请求方法
          const requestMethod = this.customerId ? request.put : request.post
          const requestUrl = this.customerId ? `/customers/${this.customerId}` : '/customers'
          
          requestMethod(requestUrl, requestData)
            .then(() => {
              this.$message.success(this.customerId ? '更新客户成功' : '添加客户成功')
              this.$router.push('/customers')
            })
            .catch(error => {
              console.error(this.customerId ? '更新客户失败:' : '添加客户失败:', error)
              this.$message.error(this.customerId ? '更新客户失败' : '添加客户失败')
            })
        }
      })
    },
    
    // 重置表单
    handleReset() {
      this.$refs.customerForm.resetFields()
      this.customerForm.longitude = null
      this.customerForm.latitude = null

      // 重置地图中心
      this.mapCenter = [87.616878, 43.82567]
    }
  }
}
</script>

<style scoped>
.customer-form-container {
  width: 100%;
}

.map-section {
  margin-bottom: 20px;
}

.map-search {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.map-search-input {
  width: 260px;
  max-width: 100%;
  flex: 1 1 220px;
}

.map-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.map-fullscreen-btn {
  padding-left: 6px;
  padding-right: 6px;
}

.map-drag-hint {
  width: 100%;
  flex-basis: 100%;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.customer-marker {
  width: 44px;
  height: 52px;
  min-width: 44px;
  min-height: 52px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  pointer-events: auto;
}

.customer-marker__icon {
  color: #f56c6c;
  font-size: 44px;
  line-height: 1;
}

.map {
  width: 100%;
  height: 300px;
  margin-bottom: 10px;
}

.map-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-controls {
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.coordinates {
  display: flex;
  gap: 20px;
  color: #606266;
}

.mobile-coordinates {
  display: block;
  margin-top: 5px;
}

.form-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.mobile-button {
  flex: 1;
  margin-bottom: 5px;
}

.mobile-form /deep/ .el-form-item__label {
  font-size: 14px;
}

.map-fullscreen-overlay {
  position: fixed;
  inset: 0;
  background: #fff;
  z-index: 2000;
  display: flex;
  flex-direction: column;
}

.map-fullscreen-header {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  z-index: 1;
}

.map-fullscreen-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.map-fullscreen-title {
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100vw - 90px);
}

.map-fullscreen-search {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.map-fullscreen-search .el-button {
  margin: 0;
}

.map-fullscreen-search-input {
  flex: 1 1 220px;
  min-width: 180px;
}

.map-fullscreen-actions {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #606266;
  flex-wrap: wrap;
}

.map-fullscreen-address {
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map-fullscreen-coord {
  width: 100%;
  white-space: normal;
  word-break: break-all;
}

.map-fullscreen-body {
  flex: 1;
  min-height: 0;
}

.map-fullscreen-map {
  width: 100%;
  height: 100%;
}

/* 全屏层淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .customer-form-container {
    padding: 0 10px;
  }

  .map-search {
    gap: 8px;
  }

  .map-search-input {
    flex: 1 1 100%;
    width: 100%;
  }

  .map-actions {
    width: 100%;
  }
  
  .map {
    height: 200px;
  }
  
  .map-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .coordinates {
    display: block;
    margin-top: 5px;
  }
  
  .form-buttons {
    flex-direction: column;
  }
  
  .form-buttons .el-button {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>